import { OrderedMap } from 'immutable';
import * as ReviewTypes from './ReviewType';
export const RatingAxes = {
  OVERALL: 'OVERALL',
  VALUE: 'VALUE',
  // Apps
  USABILITY: 'USABILITY',
  FUNCTIONALITY: 'FUNCTIONALITY',
  SUPPORT_DOCS: 'SUPPORT_DOCS',
  //Themes
  PERFORMANCE: 'PERFORMANCE',
  // Profiles
  RESULT_QUALITY: 'RESULT_QUALITY',
  CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
  COMMUNICATION: 'COMMUNICATION'
};
export const AppQualityRatingsTemplate = OrderedMap({
  [RatingAxes.USABILITY]: null,
  [RatingAxes.FUNCTIONALITY]: null,
  [RatingAxes.VALUE]: null,
  [RatingAxes.SUPPORT_DOCS]: null
});
export const ProfileQualityRatingsTemplate = OrderedMap({
  [RatingAxes.VALUE]: null,
  [RatingAxes.RESULT_QUALITY]: null,
  [RatingAxes.CUSTOMER_SERVICE]: null,
  [RatingAxes.COMMUNICATION]: null
});
export const AppRatingAxes = [RatingAxes.OVERALL, RatingAxes.VALUE, RatingAxes.USABILITY, RatingAxes.FUNCTIONALITY, RatingAxes.SUPPORT_DOCS];
export const ThemeRatingAxes = [RatingAxes.OVERALL, RatingAxes.USABILITY, RatingAxes.PERFORMANCE, RatingAxes.VALUE, RatingAxes.SUPPORT_DOCS];
export const ProfileRatingAxes = [RatingAxes.OVERALL, RatingAxes.VALUE, RatingAxes.RESULT_QUALITY, RatingAxes.CUSTOMER_SERVICE, RatingAxes.COMMUNICATION];
export const QualityRatingsByReviewType = {
  [ReviewTypes.APP]: AppRatingAxes.slice(1),
  [ReviewTypes.THEME]: ThemeRatingAxes.slice(1),
  [ReviewTypes.PROFILE]: ProfileRatingAxes.slice(1)
};